import React from 'react';
import HistoryComponent from '../../component/history/history-container';

const render = () => <HistoryComponent />;

export default render;



// WEBPACK FOOTER //
// ./src/page/history/index.js